import React from "react";
import Slider from "react-slick";
import { Container, Row, Col } from "react-bootstrap";

const SpecialPaetner = () => {
  const sliderSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 1,
    speed: 6000,
    rtl: true,
    cssEase: "linear",
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const sliderImages = [
    {
      src: "./img/plus-distribution-client-euro-life.webp",
      alt: "EuroLife Pharmaceutical Partnership Logo - Representing our trusted healthcare partner",
    },
    {
      src: "./img/plus-distribution-client-sparsh.webp",
      alt: "Special Partner - PDPL's valued business collaboration for healthcare solutions",
    },
    {
      src: "./img/plus-distribution-client-glee-biotech.webp",
      alt: "GleeBioTech Pharmaceutical Partner Logo - Delivering high-quality biotech solutions",
    },
    {
      src: "./img/plus-distribution-client-gen.png",
      alt: "PlusGen Healthcare Partnership Logo - Advancing innovative healthcare technologies",
    },
  ];
  return (
    <>
      <div className="bg_gray">
        <Container className="py-5">
          <Row className=" justify-content-lg-between justify-content-center align-items-center gap-lg-0 gap-3">
            <Col lg={7} className="text-lg-start text-center">
              <h2
                className="fw-bold fs_8xl mx-auto letter_spacing mb-2"
                data-aos="fade-right"
              >
                Our Special Partner
              </h2>
              <p
                className="fs_md letter_spacing fw- lh-base text-black text_justify"
                data-aos="fade-right"
              >
                As the exclusive C&F partner, PDPL ensures quick and smoother delivery
                of high-quality medical products and guarantees reliable access
                to essential medications for better healthcare outcomes.
              </p>
            </Col>
            <Col lg={5} xs={12}>
              <Slider {...sliderSettings}>
                {sliderImages.map((image, index) => (
                  <div key={index} className="slider-image-container">
                    <img loading="lazy" 
                      src={image.src}
                      alt={image.alt}
                      className="w-100 p-lg-4 pt-5 px-5"
                    />
                  </div>
                ))}
              </Slider>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SpecialPaetner;
